require.register("modules/m0x/a03/page-25-il/page-25-il", function(exports, require, module){
  var BaseExtension = require('base-extension');

var page25_il = _.defaults({
  initialized: function(view) {

  },
  loaded: function(view) {

  },
  playing: function(view) {

  },
  paused: function(view) {

  },
  stopped: function(view) {

  },
  completed: function(view) {
  },
  unloading: function(view, onComplete) {

    onComplete();
  }
}, BaseExtension);

module.exports = page25_il;

  
});

